<template>
    <div class="grid-container">
        <el-row class="content">
            <el-table
                ref="elTable"
                style="height: 100%;"
                :data="data"
                :highlight-current-row="true"
                :border="true"
                :row-key="row => row.id">
                <el-table-column fixed type="index" align="center" />
                <el-table-column
                    v-for="(col, i) in tableCols"
                    :key="i"
                    :fixed="i < 2"
                    :label="col.label"
                    v-bind="col"
                    header-align="center"
                    :align="col.align" />
                <el-table-column />
            </el-table>
        </el-row>
    </div>
</template>
<script>

export default {
    name: 'DataGrid',
    components: {
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            loading: true,
        };
    },
    computed: {
        tableCols() {
            return [
                {
                    prop: 'planned_date',
                    label: '日期',
                    width: 120,
                    align: 'center',
                },
                {
                    prop: 'quantity_plan',
                    label: '计划产量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'quantity_total',
                    label: '实际产量',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'achievement_rate',
                    label: '日达成率',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'produce_duration',
                    label: '生产时长',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'speed',
                    label: '生产工效(个/分钟)',
                    width: 140,
                    align: 'center',
                },
                {
                    prop: 'stoptime',
                    label: '停机时长',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'runtime',
                    label: '运行时长',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'produce_ratio',
                    label: '负荷利用率(%)',
                    width: 120,
                    align: 'center',
                },
                {
                    prop: 'started_at',
                    label: '开始时间',
                    width: 180,
                    align: 'center',
                },
                {
                    prop: 'finished_at',
                    label: '结束时间',
                    width: 180,
                    align: 'center',
                },

            ];
        },
    },
    mounted() {
        setTimeout(() => {
            console.log(this.data);
        }, 1000);
    },
    methods: {
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-container{
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: column;
}
.headbar {
}
.footbar {
}
.content {
    flex-grow: 1;
    overflow: auto;
}
</style>
